
function setCursor({ cursorValue, className }) {
  const htmlEl = document.querySelector('html');

  if (!document.body || !htmlEl) {return;}

  htmlEl.className = className;
  document.body.setAttribute('style', cursorValue);
}

function setGlobalCursor(cursor) {
  setCursor({ cursorValue: `cursor: ${cursor} !important`, className: 'reset-all-cursors' });
}

function resetGlobalCursor() {
  setCursor({ cursorValue: 'cursor: \'\'', className: '' });
}

export default { set: setGlobalCursor, reset: resetGlobalCursor };